import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import useSetState from 'core/hooks/useSetState';
import { jobs as t } from 'helpers/translation';
import distances from 'core/constants/distances';
import Select from 'components/Select';
import DropdownAutocomplete from './DropdownAutocomplete';

type Props = {
	search: any,
  places: any,
  pushToSearch: Function
};

export default ({ search, places, pushToSearch }: Props) => {
  const [{ place_id, distance }, setState] = useSetState({
    place_id: search.place_id ? search.place_id.toString() : '',
    distance: search.distance ? search.distance.toString() : ''
  });

  useEffect(() => {
    setState({
      place_id: search.place_id ? search.place_id.toString() : '',
      distance: search.distance ? search.distance.toString() : ''
    });
  }, [search]);

  const handleChange = (name: string) => (option: ?any) => {
    if (place_id.length > 0) pushToSearch({ [name]: option && option.value, page: 0 });
  };

  const handleNativeSelectChange = (name: string) => ({ target }) => {
    if (place_id.length > 0) pushToSearch({ [name]: target && target.value, page: 0 });
  };

  const handleSubmit = (id) => {
    pushToSearch({ place_id: id, distance: id ? (distance || distances[0].value) : '', page: 0 });
  };

  const handleRemovePlace = () => {
    pushToSearch({ place_id: '', distance: '', page: 0 });
  };

  return(
    <>
      <div className="col filter filter_jobs">
        <label className="filter__title" htmlFor="place">{t.place_label}</label>
        <div className="filter__close">
          <DropdownAutocomplete
            id="place"
            placeholder={t.place_placeholder}
            handleChange={(id) => handleSubmit(id)}
            defaultPlaceId={search.place_id ? search.place_id.toString() : ''}
            places={places}
            search={search}
          />
          { place_id && <button type="button" onClick={handleRemovePlace} className="icon-close"> </button> }
        </div>
      </div>

      <div className="col filter filter_jobs">
        <label className="filter__title" htmlFor="distance">{t.distance_label}</label>
        {
          isMobile
            ? <select className="filter__select" onChange={handleNativeSelectChange('distance')} disabled={!search.place_id}>
              { distances.map(({ value, label }) => <option key={value} value={value} >{label}</option> )}
            </select>
            : <Select
              isDisabled={!search.place_id}
              className="default-select"
              isSearchable={false}
              placeholder={!search.place_id ? t.choose_place_first : t.distance_placeholder}
              value={distances.find(({ value }) => +value === +search.distance ) || null}
              options={distances}
              onChange={handleChange('distance')}
            />
        }
      </div>
    </>
  );
};
